import { adjustColor, hexToRgba } from '../utils/colorUtils';

function buildCss(c, cL, cD, ca15, ca20, ca35, ca38) {
  return `
@keyframes sm-shine {
  0%   { left: -75%; }
  100% { left: 125%; }
}

.sm { font-family: system-ui, -apple-system, sans-serif; background: #0f172a; width: 100%; }

.sm-nav {
  padding: 20px 64px; display: flex; justify-content: space-between; align-items: center;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.sm-nav-logo { color: #fff; font-size: 22px; font-weight: 800; letter-spacing: -0.03em; }
.sm-nav-links { display: flex; gap: 36px; align-items: center; }
.sm-nav-link { color: rgba(255,255,255,0.5); font-size: 14px; cursor: pointer; transition: color 0.2s; }
.sm-nav-link:hover { color: #fff; }
.sm-nav-btn {
  padding: 9px 26px; background: ${c}; color: #0f172a; border: none;
  border-radius: 7px; font-weight: 800; font-size: 14px; cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}
.sm-nav-btn:hover { background: ${cL}; transform: translateY(-1px); }

.sm-hero {
  padding: 120px 64px; text-align: center; position: relative; overflow: hidden;
  background:
    radial-gradient(ellipse at 15% 40%, ${ca15} 0%, transparent 55%),
    radial-gradient(ellipse at 85% 20%, ${hexToRgba(cL, 0.15)} 0%, transparent 55%),
    radial-gradient(ellipse at 50% 90%, ${hexToRgba(cD, 0.12)} 0%, transparent 55%),
    #0f172a;
}
.sm-hero-badge {
  display: inline-flex; align-items: center; gap: 8px; padding: 6px 16px;
  background: ${ca15}; border: 1px solid ${ca35};
  border-radius: 20px; color: ${c}; font-size: 13px; font-weight: 600; margin-bottom: 36px;
}
.sm-hero-h1 {
  color: #fff; font-size: 68px; font-weight: 900; line-height: 1.08;
  letter-spacing: -0.04em; margin-bottom: 28px; position: relative;
}
.sm-hero-desc { color: rgba(255,255,255,0.55); font-size: 20px; max-width: 560px; margin: 0 auto 52px; line-height: 1.65; }
.sm-hero-btns { display: flex; gap: 16px; justify-content: center; }
.sm-hero-btn-primary {
  padding: 16px 52px; background: ${c}; color: #0f172a; border: none;
  border-radius: 9px; font-size: 16px; font-weight: 800; cursor: pointer;
  box-shadow: 0 0 40px ${ca38};
  transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
}
.sm-hero-btn-primary:hover { background: ${cL}; transform: translateY(-2px); }
.sm-hero-btn-secondary {
  padding: 16px 52px; background: transparent; color: rgba(255,255,255,0.8);
  border: 1px solid rgba(255,255,255,0.18); border-radius: 9px;
  font-size: 16px; cursor: pointer; transition: border-color 0.2s, color 0.2s;
}
.sm-hero-btn-secondary:hover { border-color: rgba(255,255,255,0.4); color: #fff; }

.sm-hero-screenshot { padding: 0 64px 80px; }
.sm-hero-img-wrap {
  position: relative; overflow: hidden; border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 32px 96px ${ca20};
  height: 400px; background-color: #f5f5f5;
}
.sm-hero-img {
  position: absolute; top: 0; left: 0; width: 100%; height: 100%;
  object-fit: contain; object-position: center; display: block;
}

.sm-stats {
  display: grid; grid-template-columns: repeat(4, 1fr);
  background: rgba(255,255,255,0.03);
  border-top: 1px solid rgba(255,255,255,0.07);
  border-bottom: 1px solid rgba(255,255,255,0.07);
}
.sm-stat-item { text-align: center; padding: 36px 16px; border-right: 1px solid rgba(255,255,255,0.07); }
.sm-stat-item:last-child { border-right: none; }
.sm-stat-num { color: ${c}; font-size: 44px; font-weight: 900; letter-spacing: -0.04em; margin-bottom: 8px; }
.sm-stat-label { color: rgba(255,255,255,0.45); font-size: 14px; }

.sm-features {
  padding: 80px 64px;
  background:
    radial-gradient(ellipse at 30% 50%, ${ca15} 0%, transparent 60%),
    radial-gradient(ellipse at 70% 50%, ${hexToRgba(cL, 0.08)} 0%, transparent 60%),
    rgba(8,15,30,0.95);
}
.sm-features-label { text-align: center; color: ${c}; font-size: 12px; letter-spacing: 0.25em; font-weight: 700; margin-bottom: 16px; }
.sm-features-h2 { text-align: center; color: #fff; font-size: 38px; font-weight: 800; margin-bottom: 14px; letter-spacing: -0.03em; }
.sm-features-sub { text-align: center; color: rgba(255,255,255,0.4); font-size: 16px; margin-bottom: 64px; }
.sm-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
.sm-feature-card {
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.1);
  border-radius: 14px; padding: 36px;
  backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
  transition: transform 0.2s, background 0.2s, border-color 0.2s;
}
.sm-feature-card:hover {
  transform: translateY(-4px);
  background: rgba(255,255,255,0.08);
  border-color: ${ca35};
}
.sm-feature-icon {
  width: 52px; height: 52px; border-radius: 12px;
  background: ${ca15}; border: 1px solid ${ca35};
  display: flex; align-items: center; justify-content: center;
  color: ${c}; font-size: 26px; margin-bottom: 22px;
}
.sm-feature-title { color: #fff; font-size: 20px; font-weight: 700; margin-bottom: 14px; }
.sm-feature-desc { color: rgba(255,255,255,0.45); line-height: 1.8; font-size: 15px; }

.sm-images { padding: 0 64px 80px; display: flex; gap: 16px; flex-wrap: wrap; justify-content: center; }
.sm-image-item {
  height: 180px; width: 240px; object-fit: contain; object-position: center; display: block;
  border-radius: 10px; border: 1px solid rgba(255,255,255,0.07);
  background-color: #f5f5f5;
  transition: transform 0.2s, border-color 0.2s;
}
.sm-image-item:hover { transform: scale(1.03); border-color: ${ca35}; }

.sm-steps { padding: 80px 64px; }
.sm-steps-h2 { text-align: center; color: #fff; font-size: 38px; font-weight: 800; margin-bottom: 72px; letter-spacing: -0.03em; }
.sm-steps-row { display: flex; gap: 0; position: relative; max-width: 880px; margin: 0 auto; }
.sm-step { flex: 1; text-align: center; position: relative; }
.sm-step-connector {
  position: absolute; top: 24px; left: 50%; right: -50%;
  height: 1px; background: ${ca35}; z-index: 0;
}
.sm-step-num {
  width: 48px; height: 48px; border-radius: 50%; background: ${c};
  color: #0f172a; display: flex; align-items: center; justify-content: center;
  font-weight: 900; font-size: 18px; margin: 0 auto 18px; position: relative; z-index: 1;
}
.sm-step-label { color: rgba(255,255,255,0.65); font-size: 14px; }

.sm-cta {
  padding: 88px 64px; text-align: center;
  background: linear-gradient(160deg, ${ca15}, transparent);
  border-top: 1px solid ${ca35};
}
.sm-cta-h2 { color: #fff; font-size: 42px; font-weight: 900; margin-bottom: 18px; letter-spacing: -0.03em; }
.sm-cta-sub { color: rgba(255,255,255,0.5); font-size: 17px; margin-bottom: 48px; }
.sm-cta-btn {
  padding: 18px 76px; background: ${c}; color: #0f172a; border: none;
  border-radius: 10px; font-size: 18px; font-weight: 900; cursor: pointer;
  position: relative; overflow: hidden;
  box-shadow: 0 0 48px ${ca38};
  transition: background 0.2s, transform 0.2s;
}
.sm-cta-btn::after {
  content: ''; position: absolute; top: -50%; left: -75%;
  width: 50%; height: 200%;
  background: linear-gradient(to right, transparent, rgba(255,255,255,0.35), transparent);
  transform: skewX(-20deg); transition: left 0s;
}
.sm-cta-btn:hover { transform: translateY(-2px); background: ${cL}; }
.sm-cta-btn:hover::after { left: 125%; transition: left 0.5s; }

.sm-footer {
  padding: 32px 64px; border-top: 1px solid rgba(255,255,255,0.07);
  display: flex; justify-content: space-between; color: rgba(255,255,255,0.3); font-size: 13px;
}

@media (max-width: 768px) {
  .sm-nav { padding: 14px 20px; }
  .sm-nav-links { display: none; }
  .sm-hero { padding: 72px 20px; }
  .sm-hero-h1 { font-size: 36px; }
  .sm-hero-btns { flex-direction: column; align-items: center; }
  .sm-hero-screenshot { padding: 0 20px 56px; }
  .sm-hero-img-wrap { height: 240px; }
  .sm-stats { grid-template-columns: repeat(2, 1fr); }
  .sm-stat-item:nth-child(2) { border-right: none; }
  .sm-features { padding: 56px 20px; }
  .sm-features-grid { grid-template-columns: 1fr; gap: 16px; }
  .sm-images { padding: 0 20px 56px; }
  .sm-image-item { width: 100%; height: 160px; }
  .sm-steps { padding: 56px 20px; }
  .sm-steps-row { flex-direction: column; align-items: center; gap: 32px; }
  .sm-step-connector { display: none; }
  .sm-cta { padding: 64px 20px; }
  .sm-cta-h2 { font-size: 28px; }
  .sm-footer { padding: 24px 20px; flex-direction: column; gap: 8px; }
}
`;
}

export default function StartupModern({ data }) {
  const c    = data.color || '#06b6d4';
  const cL   = adjustColor(c, 18);
  const cD   = adjustColor(c, -15);
  const ca15 = hexToRgba(c, 0.15);
  const ca20 = hexToRgba(c, 0.2);
  const ca35 = hexToRgba(c, 0.35);
  const ca38 = hexToRgba(c, 0.38);

  const stats = [
    { num: '500社+', label: '導入企業数' },
    { num: '98%',   label: '継続率' },
    { num: '3倍',   label: '平均ROI' },
    { num: '24/7',  label: 'サポート対応' },
  ];

  return (
    <>
      <style>{buildCss(c, cL, cD, ca15, ca20, ca35, ca38)}</style>
      <div className="sm">
        <nav className="sm-nav">
          <span className="sm-nav-logo">{data.siteName}</span>
          <div className="sm-nav-links">
            {['プロダクト', '事例', '料金'].map(item => (
              <span key={item} className="sm-nav-link">{item}</span>
            ))}
            <button className="sm-nav-btn">{data.cta}</button>
          </div>
        </nav>

        <div className="sm-hero">
          <div className="sm-hero-badge">✦ 新機能をリリースしました</div>
          <h1 className="sm-hero-h1">{data.heroHeading}</h1>
          <p className="sm-hero-desc">{data.description}</p>
          <div className="sm-hero-btns">
            <button className="sm-hero-btn-primary">{data.cta}</button>
            <button className="sm-hero-btn-secondary">デモを見る</button>
          </div>
        </div>

        {data.heroImage && (
          <div className="sm-hero-screenshot">
            <div className="sm-hero-img-wrap">
              <img src={data.heroImage} alt="" className="sm-hero-img" />
            </div>
          </div>
        )}

        <div className="sm-stats">
          {stats.map((s, i) => (
            <div key={i} className="sm-stat-item">
              <div className="sm-stat-num">{s.num}</div>
              <div className="sm-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="sm-features">
          <p className="sm-features-label">FEATURES</p>
          <h2 className="sm-features-h2">主な機能</h2>
          <p className="sm-features-sub">{data.tagline}</p>
          <div className="sm-features-grid">
            {data.features.map((f, i) => (
              <div key={i} className="sm-feature-card">
                <div className="sm-feature-icon">⚡</div>
                <h3 className="sm-feature-title">{f.title}</h3>
                <p className="sm-feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {data.images && data.images.length > 0 && (
          <div className="sm-images">
            {data.images.slice(0, 4).map((img, i) => (
              <img key={i} src={img} alt="" className="sm-image-item" />
            ))}
          </div>
        )}

        <div className="sm-steps">
          <h2 className="sm-steps-h2">導入ステップ</h2>
          <div className="sm-steps-row">
            {['無料相談', '提案・見積', '契約・開始', '運用サポート'].map((step, i) => (
              <div key={i} className="sm-step">
                {i < 3 && <div className="sm-step-connector" />}
                <div className="sm-step-num">{i + 1}</div>
                <p className="sm-step-label">{step}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="sm-cta">
          <h2 className="sm-cta-h2">まずは無料で試してみる</h2>
          <p className="sm-cta-sub">{data.tagline}</p>
          <button className="sm-cta-btn">{data.cta}</button>
        </div>

        <footer className="sm-footer">
          <span>{data.siteName}</span>
          <span>© 2025</span>
        </footer>
      </div>
    </>
  );
}
